import React from "react";
import { RetailersMap, RetailerDetails, RetailersPopupMap } from "./";
import { Route, Switch } from "react-router-dom";


const Retailers = ({match}) => {
    return ( 
        <div>
            <Switch>
                <Route exact path={`/retailers`} component={RetailersMap} />
                <Route path={`/retailers/:dealerUniqueName`} component={RetailerDetails} />
                <Route exact path={`/book-test-drive`} component={RetailersPopupMap} />
                <Route exact path={`/request-a-booking`} component={RetailersMap} />
                <Route exact path={`/service-booking`} component={RetailersMap} />
                <Route exact path={`/xtime-service-booking`} component={RetailersMap} />
                <Route exact path={`/showroom-consultation`} component={RetailersMap} />
            </Switch>
        </div>
    );
};

export default Retailers;